import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import useAuth from 'src/hooks/useAuth'
import useLayoutContext from 'src/hooks/useAuthLayout'
import confirmSweetAlert from 'src/utils/confirm'
import Paciente from '../cita_admision/Paciente'

export default function Inconformidad() {
    const { drawerOpen, mostrarComponent } = useLayoutContext()
    const [tabs] = useState([{ value: '01', label: 'Documento', active: true }])
    const [selected, setSelected] = useState({ paciente: { item: null, selected: false } })
    const [pacienteWsp, setPacienteWsp] = useState('')
    const [motivo] = useState('No encontre horarios disponibles')
    const { user } = useAuth()
    const handleSleccionarPaciente = async (id, item) => {
        setSelected(x => {
            return {
                ...x,
                [id]: {
                    item,
                    selected: true
                }
            }
        })
    }
    useEffect(() => {
        handleLimpiarAll()
    }, [tabs])
    const handleLimpiarAll = () => {
        setSelected({ paciente: { item: null, selected: false } })
    }
    const handleGuardarRegistro = async () => {

        let rpta = await confirmSweetAlert('Grabar inconformidad', '¿Seguro que desea grabar la observación?', 'warning', true)
        if (rpta) {
            let response = await axios.post('https://apis-anterior.vesaliohce.com.pe/inconformidadCallCenter', {
                motivo,
                fecha: drawerOpen.item.fecha.split('/').join('-'),
                paciente: selected.paciente.item,
                pacienteWsp,
                doctor: {
                    Nombres: drawerOpen.item.datos.datosDoctor.toUpperCase(),
                    especialidad: drawerOpen.item.datos.nombre.toUpperCase(),
                    especialidad_id: drawerOpen.item.datos.especialidad_id,
                    personal_id: drawerOpen.item.datos.personal_id
                },
                user: {
                    datos: user.datos.ape_paterno + ' ' + user.datos.ape_materno + ' ' + user.datos.nombres,
                    tipoUsuario: user.cuenta.tipo_usuario
                }
            })
            console.log(response)
            if (response.status === 200) {
                await confirmSweetAlert('Correcto', 'Grabado correctamente', 'success', false)
                mostrarComponent({
                    contenido: '',
                    estado: false,
                }, 'drawerOpen')
            }

        }

    }
    return (
        <>

            {!selected.paciente.selected && <Paciente handleSleccionarPaciente={handleSleccionarPaciente} />}
            {selected.paciente.selected && <>
                <Grid alignItems="center" justifyContent={"center"} container spacing={3} sx={{ p: 2 }}>
                    <Grid item xs={12} lg={10} md={10}>
                        <Box display="flex" alignItems="center">
                            <Box ml={1.5}>
                                <Typography color="text.primary" variant="h4" noWrap>
                                    {selected.paciente.item.Des_ApePaterno + ' ' + selected.paciente.item.Des_ApeMaterno + ' ' + selected.paciente.item.Des_Nombres}
                                </Typography>
                                <Typography variant="subtitle1" noWrap>
                                    {tabs.find(x => x.active).value === '02' ? 'Sin documentos' : selected.paciente.item.Nro_DocIdenti}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={2} md={2}>
                        <Button variant="outlined" size='small' sx={{ float: 'right' }}
                            onClick={() => handleLimpiarAll()}>
                            Limpiar
                        </Button>
                    </Grid>

                    <Grid item xs={12} lg={12} md={12} sx={{ mx: 2 }}>
                        <TextField
                            variant="outlined"
                            label={'Motivo'}
                            value={motivo}
                            disabled
                            fullWidth
                            type={'text'}
                            placeholder={'Ingrese motivo'}
                        />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12} sx={{ mx: 2 }}>
                        <TextField
                            variant="outlined"
                            label={'WhatsApp del paciente con el que va a generar la cita'}
                            value={pacienteWsp}
                            onChange={(e) => setPacienteWsp(e.target.value)}
                            fullWidth
                            type={'number'}
                            placeholder={'Ingrese número de whatsapp'}
                        />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12} sx={{ mx: 2 }}>
                        <Button variant='contained'
                            onClick={handleGuardarRegistro}
                            fullWidth>Grabar</Button>
                    </Grid>
                </Grid>
            </>}


        </>
    )
}
